import React, { FC, useContext } from "react";

import { Context } from "../../../store/student";

import Banner from "./Banner";
import styles from "./Notice.module.scss";

type Props = {
  createCareerSheets: () => void;
};

const Notice: FC<Props> = ({ createCareerSheets }) => {
  const { contextState } = useContext(Context);

  const feedbackQuestions = contextState.career_feedback_questions;

  const unansweredQuestionIndex = feedbackQuestions.findIndex(
    question => question.realization === null,
  );

  const currentQuestion =
    unansweredQuestionIndex !== -1
      ? feedbackQuestions[unansweredQuestionIndex]
      : null;

  const isCompletedQuestions = feedbackQuestions.every(
    question => question.realization !== null,
  );

  const isQuestionActive =
    feedbackQuestions.length !== 0 && !isCompletedQuestions;

  const isSheetActive = feedbackQuestions.length !== 0 && isCompletedQuestions;

  const isNoticeActive = isQuestionActive || isSheetActive;

  return (
    <>
      {isNoticeActive && (
        <div className={styles.wrapper}>
          {isQuestionActive && (
            <Banner
              type={"question"}
              chartCount={unansweredQuestionIndex}
              chartLength={feedbackQuestions.length}
              questionTitle={currentQuestion?.title}
            />
          )}
          {isSheetActive && (
            <Banner type={"sheet"} createCareerSheets={createCareerSheets} />
          )}
        </div>
      )}
    </>
  );
};

export default Notice;
